var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueBannerMobile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 916.558,
    height: 722.928,
    viewBox: "0 0 916.558 722.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forma_albastra_mare",
    "data-name": "Forma albastra mare",
    d: "M706.12.086C816.559,2.1,764.886,116.212,774.812,179.4c14.339,91.293,55.941,150.321,56.848,229.575.91,79.522,14.873,65.935-75.841,105.69-61.622,27.005-262.455,87.3-372.354,85.3C112.78,595.037-23.4,482.519,3.3,343.007S435.435-4.841,706.12.086Z",
    transform: "translate(93.863 0) rotate(9)",
    fill: "#78cfc0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBannerMobile);
export default __webpack_public_path__ + "static/media/blueBannerMobile.bbad2904a7d7a090cbc75b6a7be4a914.svg";
export { ForwardRef as ReactComponent };